import { render, staticRenderFns } from "./ItemContactLens.vue?vue&type=template&id=b21c2608&"
import script from "./ItemContactLens.vue?vue&type=script&lang=ts&"
export * from "./ItemContactLens.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports